<template>
   <div class="live-item mouse-style inner" v-if="item&&Object.keys(item).length" @click.stop="lookDetail(item)">
         <div class="img-wrap">
           <img :src="item.url" alt="">
           <span class="live-status" :class="{'trailer':item.liveStatus === 1,'living':item.liveStatus === 2,'live-end': item.liveStatus === 3,'see-history':item.liveStatus === 4}">{{item.liveStatus | filterLiveStatus}}</span>
        </div>
        <div class="title common-ecllipse" :title="item.title">{{item.title}}</div>
        <div class="time-show"><img :src="require('@/assets/image/time@2x.png')" class="desc-icon" alt=""/>{{item.startTimeStr ? item.startTimeStr : '暂无数据'}}</div>
        <div class="speaker"><img :src="require('@/assets/image/man@2x.png')" class="desc-icon" alt=""/>{{item.speaker ? item.speaker : '暂无数据'}}</div>
   </div>
</template>
<script>
export default {
  props: {
    item: {}
  },
  methods: {
    lookDetail (item) {
      this.$emit('look', item)
    }
  },
  filters: {
    filterLiveStatus (val) {
      val = Number(val)
      if (val === 1) {
        return '预告'
      }
      if (val === 2) {
        return '直播中'
      }
      if (val === 3) {
        return '直播结束'
      }
      if (val === 4) {
        return '回放'
      }
      return ''
    }
  }
}
</script>
<style lang="scss" scoped>
$listRadius:6px;
.live-item{
  display:inline-block;
  box-sizing:border-box;
  margin-bottom:24px;
  margin-right:24px;
}
.inner{
  background:#fff;
  border-radius:$listRadius;
}
.img-wrap {
  position:relative;
  width: 100%;
  height: 0;
  padding-bottom: 50%;
}
.img-wrap img{
  width:100%;
  height:100%;
  position: absolute;
  top: 0;
  left: 0;
  border-top-right-radius:$listRadius;
  border-top-left-radius:$listRadius;
}
.live-status{
  color:#fff;
  position:absolute;
  right:0;
  top:0;
  font-size:12px;
  padding:4px 11px;
  text-align:center;
  border-bottom-left-radius: $listRadius;
  border-top-right-radius:$listRadius;
}
.title,.time-show,.speaker{
  padding:0 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.time-show,.speaker{
  font-size: 12px;
}
.title{
  padding-top:5px;
  font-size:14px;
}
.speaker{
  padding-bottom:5px;
}
.time-show,.speaker,.desc-icon{
  color:#999999;
}
.desc-icon{
  width:10px;
  height:10px;
  margin-right:4px;
}
.trailer{
  background:#FF8739;
}
.living{
 background:#EA3A43;
}
.live-end{
  background:green;
}
.see-history{
  background:gray;
}
</style>
